import { render, staticRenderFns } from "./AllowedAgencyReportsView.vue?vue&type=template&id=00a50dd0&scoped=true&"
import script from "./AllowedAgencyReportsView.vue?vue&type=script&lang=js&"
export * from "./AllowedAgencyReportsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a50dd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VLayout})
